import { jwtDecode } from 'jwt-decode';

import { storage, StorageKeys } from '@/services/storage';

const TOKEN_EXPIRY_PERIOD = import.meta.env.VITE_TOKEN_EXPIRY_PERIOD;

export const setGxToken = (token: string) => {
  storage.set(StorageKeys.GxToken, token);
  const exp = jwtDecode(token).exp;
  storage.set(StorageKeys.TokenExpiry, exp ? exp - TOKEN_EXPIRY_PERIOD : 0);
};

export const setImpostorToken = (token: string, impersonatorEmail: string) => {
  const current = storage.get(StorageKeys.GxToken);
  if (!current) return;
  if (!storage.get(StorageKeys.CachedToken)) storage.set(StorageKeys.CachedToken, current);
  storage.set(StorageKeys.GxToken, token);
  storage.set(StorageKeys.Impersonator, impersonatorEmail);
  storage.remove(StorageKeys.TripToken);
};
